import axiosInstance from "./axios.instance";

export const API_GET_ZOHO_CONFIG = async () => {
  try {
    const response = await axiosInstance.get("/zoho/config");
    return response.data;
  } catch (error) {
    console.log("Error in API_GET_ZOHO_CONFIG:", error);
    throw error;
  }
};


export const API_POST_ZOHO_AUTH = async (data) => {
  try {
    const response = await axiosInstance.post("/zoho/auth",data);
    return response.data;
  } catch (error) {
    console.log("Error in API_GET_ZOHO_CONFIG:", error);
    throw error;
  }
};


export const API_GET_ZOHO_LEADS = async () => {
  try {
    const response = await axiosInstance.get("/zoho/config");
    return response.data;
  } catch (error) {
    console.log("Error in API_GET_ZOHO_LEADS:", error);
    throw error;
  }
};

export const API_GET_ZOHO_CONTACTS = async () => {
  try {
    const response = await axiosInstance.get("/zoho/contacts");
    return response.data;
  } catch (error) {
    console.log("Error in API_GET_ZOHO_CONTACTS:", error);
    throw error;
  }
};